<template>
  <v-dialog persistent fullscreen v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Cari Hareket - {{ this.currentProp ? this.currentProp.code + ' ' + this.currentProp.name : '' }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="py-3 d-flex">
          <div>
            <PrintPage :divId="'printCurrentAction'"></PrintPage>
            <ExcelExport
                :dataProp="currentActionList"
                :columnProp="currentActionListHeaders"
                :fileNameProp="this.currentProp ? 'Cari Stok Hareketleri ' + this.currentProp.code + ' ' + this.currentProp.name : ''"
            >

            </ExcelExport>

          </div>

          <div class="ms-auto d-flex">
            <v-select
                class="mr-5 mt-5 pt-3"
                v-model="dashboardFilterReportDbName"
                placeholder="Tüm Şirketler"
                clearable
                solo
                filled
                dense
                :items="companyList"
                :item-text="item => item.name"
                :item-value="item => item.name"
            >
            </v-select>
            <v-text-field
                v-model="searchText"
                class="mt-5 pt-3"
                outlined
                rounded
                dense
                placeholder="Arama Yapın..."
                clearable
                hide-details
                append-icon="mdi-magnify"
                @click:append="searchListWithText()"
                @keydown.enter="searchListWithText()"
            >

            </v-text-field>
          </div>
        </div>
        <div>
          <b-table
              :items="currentActionList"
              :fields="currentActionListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="currentActionListLoading"
              id="printCurrentAction"
              head-row-variant="info"
              table-variant="white"
              show-empty
              style="font-size:12px"
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : noCurrentMessage ? noCurrentMessage : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(actionDate)="data">
              {{ formattedDate(data.item.actionDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(expiryDate)="data">
              {{ formattedDate(data.item.expiryDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(debit)="data">
              {{ numberConverter(data.item.debit) }}
            </template>
            <template v-if="isCurrencyActive" #cell(currencyDebit)="data">
              {{ numberConverter(data.item.currencyDebit) }}
            </template>
            <template #cell(credit)="data">
              {{ numberConverter(data.item.credit) }}
            </template>
            <template v-if="isCurrencyActive" #cell(currencyCredit)="data">
              {{ numberConverter(data.item.currencyCredit) }}
            </template>
            <template #cell(balance)="data">
              {{ numberConverter(data.item.balance) }}
            </template>
            <template #cell(process)="data" :class="'exclude-print'">
              <div>
                <v-menu
                    :v-model="showActionsMenu"
                    bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="!(data.item.actionType===1 || data.item.actionType===2)"
                        class="mx-1"
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="showActionsMenu = data.item.code"
                    >
                      İşlemler
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                        @click="openCurrentEFatura(data.item)"
                        v-show="data.item.actionType===1"
                    >
                      <v-list-item-icon>
                        <v-icon color="primary"> mdi-contactless-payment-circle-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>E-Fatura</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-show="data.item.actionType===1 || data.item.actionType===2"
                        @click="openCurrentActionDetailListDialog(data.item)"
                    >
                      <v-list-item-icon>
                        <v-icon color="amber">mdi-text-box-search-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Hareket Detay</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
            <template v-if="currentActionList" #custom-foot>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Toplam Borç : <b>{{ numberConverter(totalDebit) }}</b></td>
                <td v-if="isCurrencyActive">Toplam Dövizli Borç : <b>{{ numberConverter(totalCurrencyDebit)  }}</b></td>
                <td>Toplam Alacak : <b>{{ numberConverter(totalCredit)  }}</b></td>
                <td v-if="isCurrencyActive">Toplam Dövizli Alacak : <b>{{ numberConverter(totalCurrencyCredit)  }}</b></td>
                <td>Toplam Bakiye : <b>{{ numberConverter(totalBalance) }}</b></td>
              </tr>



            </template>
          </b-table>
        </div>
        <CurrentActionDetailsDialog :showDialog="currentActionDetailListDialog"
                                    :currentActionProp="currentActionProp"
                                    @dialogChange="data => currentActionDetailListDialog = data"
                                    :reportDbNameProp="reportDbNameProp"
        ></CurrentActionDetailsDialog>
        <CurrentActionEFatura :showDialog="currentEFatura" :currentEFaturaProp="currentEFaturaProp" @dialogChange="data => currentEFatura = data"></CurrentActionEFatura>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex';
import {formattedDate} from "@/momentHelper";
import {printView} from "../../../../helpers";
import ExcelExport from "@/components/shared/ExcelExport";
import PrintPage from "@/components/shared/PrintPage";
import CurrentActionDetailsDialog from "@/components/current/dialogs/CurrentActionDetailsDialog";
import {numberConverter} from "../../../../helpers";
import CurrentActionEFatura from "@/components/current/dialogs/CurrentActionEFatura.vue";

export default {
  name: "CurrentActionsDialog",
  components: {
    CurrentActionEFatura,
    ExcelExport,
    PrintPage,
    CurrentActionDetailsDialog
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapState("company", ["companyList"]),
    ...mapState("current", ["currentActionList", "currentActionListHeaders", "currentActionListLoading","noCurrentMessage"]),

    isCurrencyActive () {
      return this.erpSettings?.netsisCurrencySale;
    }
  },
  mounted() {
    this.fetchCompanyList({
      params: {},
      body: {}
    });
  },
  data() {
    return {
      dashboardFilterReportDbName: null,
      dialog: false,
      perPage: 10,
      currentPage: 1,
      searchText: "",
      totalDebit: 0,
      totalCurrencyDebit: 0,
      totalCredit: 0,
      totalCurrencyCredit: 0,
      totalBalance: 0,
      currentActionDetailListDialog: false,
      currentEFatura: false,
      currentEFaturaProp: null,
      currentActionProp: null,
      showActionsMenu: false,
      reportDbNameProp: null,
    };
  },
  methods: {
    numberConverter,
    ...mapActions("current", ["fetchCurrentActionList"]),
    ...mapMutations("current", ["setCurrentActionList"]),
    ...mapActions("company", ["fetchCompanyList"]),

    printView,
    formattedDate,
    closeDialog() {
      this.dialog = false;
      this.searchText = null;
    },
    searchListWithText() {
      this.initCurrentActionList();
    },
    async initCurrentActionList() {
      await this.fetchCurrentActionList({
        params: {},
        body: {
          Code: this.currentProp.code,
          ...(!(this.searchText === "" || this.searchText === null)) && {SearchText: this.searchText},
          ...(!(this.dashboardFilterReportDbName === "" || this.dashboardFilterReportDbName === null)) && {ReportDbName: this.dashboardFilterReportDbName},
        }
      });
      this.totalDebit = 0;
      this.totalBalance = 0;
      this.totalCredit = 0;
      this.totalCurrencyCredit = 0;
      this.totalCurrencyDebit = 0;

      this.currentActionList.map((item) => {
        this.calculateTotalDebit(item.debit);
        this.calculateTotalCredit(item.credit);
        this.calculateTotalBalance(item.balance);
      });
      this.currentActionList.map((item) => {
        this.calculateTotalCurrencyDebit(item.currencyDebit);
        this.calculateTotalCurrencyCredit(item.currencyCredit);
      });

    },
    calculateTotalDebit(amount) {
      this.totalDebit = this.totalDebit + amount;
    },
    calculateTotalCredit(amount) {
      this.totalCredit = this.totalCredit + amount;
    },
    calculateTotalBalance(amount) {
      this.totalBalance = amount;
    },
    calculateTotalCurrencyDebit(amount) {
      this.totalCurrencyDebit = this.totalCurrencyDebit + amount;
    },
    calculateTotalCurrencyCredit(amount) {
      this.totalCurrencyCredit = this.totalCurrencyCredit + amount;
    },
    openCurrentActionDetailListDialog(data){
      this.currentActionProp = data;
      this.currentActionDetailListDialog = true;
    },
    openCurrentEFatura(data){
      this.currentEFaturaProp = data;
      this.currentEFatura=true;
    },
    setReportDbName(data) {
      this.reportDbNameProp = data;
    }
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
        this.initCurrentActionList();
      else
        this.setCurrentActionList([])

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    dashboardFilterReportDbName: function (newValue) {
      this.setReportDbName(newValue);
      this.initCurrentActionList()
    },
  }
}
</script>

<style scoped>

</style>